<template>
  <div class="progress-bar-container flex flex-auto flex-row">
    <div
        v-for="index in currentStep"
        :key="index"
        class="flex-auto bar-filled"></div>
    <div
        v-for="index in totalSteps-currentStep"
        :key="index+currentStep"
        class="flex-auto bar-empty"></div>
  </div>
</template>
<script>
export default {
  name: "StepProgressBar",
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    totalSteps: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style>
.progress-bar-container {
  width: 100%;
  position: relative;
  top: 58px;
  height: 6px;
  z-index: 2;
  gap: 4px;
}

.bar-filled {
  height: 6px;
  background: #1476ad;
  border-radius: 12px;
}

.bar-empty {
  height: 6px;
  background: #dee5ec;
  border-radius: 12px;
}
</style>
